import { render, staticRenderFns } from "./MemberAlias.vue?vue&type=template&id=7edd38ea&scoped=true"
import script from "./MemberAlias.vue?vue&type=script&lang=js"
export * from "./MemberAlias.vue?vue&type=script&lang=js"
import style0 from "./MemberAlias.vue?vue&type=style&index=0&id=7edd38ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edd38ea",
  null
  
)

export default component.exports